export enum KnmEditStatusesEnum {
  ENABLED = 'ENABLED',
  WAITING_ENABLE = 'WAITING_ENABLE',
  ENABLED_WAITING_OTHER = 'ENABLED_WAITING_OTHER',
  READ_ONLY = 'READ_ONLY',
}
